import { Accordion, Text } from '@hopskipdrive/react-components';
import { Popover as MuiPoppover } from '@mui/material';
import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../variables';
import { sidebarFocusVisibleStyles } from '../styles';

export const Popover = styled(MuiPoppover)`
  .MuiPopover-paper {
    top: unset !important;
    bottom: 0;
  }
`;

export const ProfileMenu = styled.div`
  background-color: ${colorTokens.navigation.background};
  width: 15rem;
  padding: 20px 16px;
`;

export const Header = styled(Text)`
  &.MuiTypography-root {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const Subheader = styled(Text)`
  &.MuiTypography-root {
    color: ${colorTokens.background.default};
    opacity: 0.66;
  }
`;

export const Divider = styled.div`
  opacity: 0.6;
  border: 1px solid #335d87;
  width: 100%;
  margin: 13px 0;
`;

export const Link = styled(Text)`
  &.MuiTypography-root {
    color: ${colorPalette.blue93};
    line-height: 24px;
    cursor: pointer;

    a.MuiLink-root {
      color: ${colorPalette.blue93};
    }
  }
`;

export const MobileAccordion = styled(Accordion)`
  &.MuiAccordion-root:before {
    display: none;
  }
  && .MuiAccordionSummary-root {
    display: -webkit-box;
    padding: 0;

    &.Mui-focusVisible {
      background-color: transparent;
      box-shadow: none;
    }

    &:focus-visible {
      ${sidebarFocusVisibleStyles}
      border-radius: 14px;
    }
  }
  .MuiAccordionSummary-content {
    margin: 0;
    border: 0;
    > .MuiBox-root {
      margin: 8px 8px 0 0;
      min-width: 0;

      > .MuiTypography-root {
        min-width: 0;
      }
    }
  }
  && .MuiAccordionSummary-content ${Header} {
    color: inherit;
  }
  .MuiAccordionDetails-root {
    border: 0;
    .MuiBox-root {
      margin: 0 32px 8px;
    }
  }
`;
